seo:
  siteTitle: Documentation Tale
  ogImageAlt: Logo Tale
nav:
  homeAriaLabel: Accueil de la documentation Tale
  sidebarAriaLabel: Documentation
  groups:
    start: Commencer ici
    cloud: Cloud
    selfHosted: Auto-hébergé
    install: Installation
    configuration: Configuration
    operate: Exploitation
    observability: Observabilité
    security: Sécurité
    releaseNotes: Notes de version
    authentication: Authentification
    platform: Plateforme
    chat: Chat
    workspace: Espace de travail
    agents: Agents
    automations: Automatisations
    knowledge: Connaissances
    connectors: Connectors
    member: Membre
    editor: Éditeur
    developer: Développeur
    admin: Administration
    tutorials: Tutoriels
    develop: Développement
    projects: Projets
    approvals: Approbations
    governance: Gouvernance
    legal: Mentions légales
    tutorialsAdmin: Administration
    tutorialsEditor: Éditeur
    tutorialsDeveloper: Développeur
    tutorialsMember: Membre
    tutorialsVideos: Vidéos
docs:
  home: Accueil
pwa:
  updateAvailableTitle: Mise à jour disponible
  updateAvailableDescription: Une nouvelle version de la doc est prête.
  updateNow: Recharger
  updateLater: Plus tard
  dismiss: Ignorer
  offlineReady: La page hors ligne est prête.
